import { SectionDataById } from '@src/app-components/dynamic-form/types';
import { nwpQuestions } from './nonPcnData.nwpQuestions';
import { generalConditionQuestions } from './nonPcnData.generalConditionQuestions';

export const sectionsById: SectionDataById = {
  1: {
    formId: 1,
    sectionName: 'NWP Type Selection',
    questions: nwpQuestions.nonPcnQuestions,
  },
  2: {
    formId: 1,
    sectionName: 'NWP - General Questions',
    questions: nwpQuestions.nwpGeneralQuestions,
  },
  3: {
    formId: 1,
    sectionName: 'NWP 1 - Aids to Navigation',
    questions: nwpQuestions.nwp1Questions,
  },
  4: {
    formId: 1,
    sectionName: 'NWP 2 - Structures in Artificial Canals',
    questions: nwpQuestions.nwp2Questions,
  },
  5: {
    formId: 1,
    sectionName: 'NWP 3 - Maintenance',
    questions: nwpQuestions.nwp3Questions,
  },
  6: {
    formId: 1,
    sectionName: 'NWP 4 - Fish and Wildlife Harvesting, Enhancement, and Attraction Devices and Activities',
    questions: nwpQuestions.nwp4Questions,
  },
  7: {
    formId: 1,
    sectionName: 'NWP 5 - Scientific Measuring Devices',
    questions: nwpQuestions.nwp5Questions,
  },
  8: {
    formId: 1,
    sectionName: 'NWP 6 - Survey Activities',
    questions: nwpQuestions.nwp6Questions,
  },
  9: {
    formId: 1,
    sectionName: 'NWP 9 - Structures in Fleeting and Anchorage Areas',
    questions: nwpQuestions.nwp9Questions,
  },
  10: {
    formId: 1,
    sectionName: 'NWP 10 - Mooring Buoys',
    questions: nwpQuestions.nwp10Questions,
  },
  11: {
    formId: 1,
    sectionName: 'NWP 11 - Temporary Recreational Structures',
    questions: nwpQuestions.nwp11Questions,
  },
  12: {
    formId: 1,
    sectionName: 'NWP 12 - Oil or Natural Gas Pipeline Activities',
    questions: nwpQuestions.nwp12Questions,
  },
  13: {
    formId: 1,
    sectionName: 'NWP 13 - Bank Stabilization',
    questions: nwpQuestions.nwp13Questions,
  },
  14: {
    formId: 1,
    sectionName: 'NWP 14 - Linear Transportation Projects',
    questions: nwpQuestions.nwp14Questions,
  },
  15: {
    formId: 1,
    sectionName: 'NWP 15 - US Coast Guard Approved Bridges',
    questions: nwpQuestions.nwp15Questions,
  },
  16: {
    formId: 1,
    sectionName: 'NWP 16 - Return Water from Upland Disposal Areas',
    questions: nwpQuestions.nwp16Questions,
  },
  17: {
    formId: 1,
    sectionName: 'NWP 18 - Minor Discharges',
    questions: nwpQuestions.nwp18Questions,
  },
  18: {
    formId: 1,
    sectionName: 'NWP 19 - Minor Dredging',
    questions: nwpQuestions.nwp19Questions,
  },
  19: {
    formId: 1,
    sectionName: 'NWP 20 - Response Operations for Oil or Hazardous Substances',
    questions: nwpQuestions.nwp20Questions,
  },
  20: {
    formId: 1,
    sectionName: 'NWP 22 - Removal of Vessels',
    questions: nwpQuestions.nwp22Questions,
  },
  21: {
    formId: 1,
    sectionName: 'NWP 23 - Approved Categorical Exclusions',
    questions: nwpQuestions.nwp23Questions,
  },
  22: {
    formId: 1,
    sectionName: 'NWP 24 - Indian Tribe or State Administered Section 404 Programs',
    questions: nwpQuestions.nwp24Questions,
  },
  23: {
    formId: 1,
    sectionName: 'NWP 25 - Structural Discharges',
    questions: nwpQuestions.nwp25Questions,
  },
  24: {
    formId: 1,
    sectionName: 'NWP 28 - Modifications to Existing Marinas',
    questions: nwpQuestions.nwp28Questions,
  },
  25: {
    formId: 1,
    sectionName: 'NWP 30 - Moist Soil Management for Wildlife',
    questions: nwpQuestions.nwp30Questions,
  },
  26: {
    formId: 1,
    sectionName: 'NWP 33 - Temporary Construction, Access, and Dewatering',
    questions: nwpQuestions.nwp33Questions,
  },
  27: {
    formId: 1,
    sectionName: 'NWP 35 - Maintenance Dredging of Existing Basins',
    questions: nwpQuestions.nwp35Questions,
  },
  28: {
    formId: 1,
    sectionName: 'NWP 36 - Boat Ramps',
    questions: nwpQuestions.nwp36Questions,
  },
  29: {
    formId: 1,
    sectionName: 'NWP 41 - Reshaping Existing Drainage and Irrigation Ditches',
    questions: nwpQuestions.nwp41Questions,
  },
  30: {
    formId: 1,
    sectionName: 'NWP 43 - Stormwater Management Facilities',
    questions: nwpQuestions.nwp43Questions,
  },
  31: {
    formId: 1,
    sectionName: 'NWP 48 - Commercial Shellfish Mariculture Activities',
    questions: nwpQuestions.nwp48Questions,
  },
  32: {
    formId: 1,
    sectionName: 'NWP 51 - Land-Based Renewable Energy Generation Facilities',
    questions: nwpQuestions.nwp51Questions,
  },
  33: {
    formId: 1,
    sectionName: 'NWP 57 - Electric Utility Line and Telecommunications',
    questions: nwpQuestions.nwp57Questions,
  },
  34: {
    formId: 1,
    sectionName: 'NWP 58 - Utility Line Activities for Water and Other Substances',
    questions: nwpQuestions.nwp58Questions,
  },
  35: {
    formId: 1,
    sectionName: 'NWP 60 - Activities to Improve Passage of Fish and Other Aquatic Organisms',
    questions: nwpQuestions.nwp60Questions,
  },
  36: {
    formId: 1,
    sectionName: 'NWP - General Conditions',
    isHeader: true,
  },

  37: {
    formId: 2,
    sectionName: 'Navigation',
    questions: generalConditionQuestions.navigationQuestions,
  },
  38: {
    formId: 2,
    sectionName: 'Aquatic Life Movement',
    questions: generalConditionQuestions.aquaticLifeMovementQuestions,
  },
  39: {
    formId: 2,
    sectionName: 'Spawning Areas',
    questions: generalConditionQuestions.spawningAreaQuestions,
  },
  40: {
    formId: 2,
    sectionName: 'Migratory Bird Breeding Areas',
    questions: generalConditionQuestions.migratoryBirdQuestions,
  },
  41: {
    formId: 2,
    sectionName: 'Shellfish Beds',
    questions: generalConditionQuestions.shellfishBedQuestions,
  },
  42: {
    formId: 2,
    sectionName: 'Suitable Material',
    questions: generalConditionQuestions.suitableMaterialQuestions,
  },
  43: {
    formId: 2,
    sectionName: 'Water Supply Intakes',
    questions: generalConditionQuestions.waterSupplyQuestions,
  },
  44: {
    formId: 2,
    sectionName: 'Adverse Effects From Impoundments',
    questions: generalConditionQuestions.adverseImpoundmentQuestions,
  },
  45: {
    formId: 2,
    sectionName: 'Management of Water Flows',
    questions: generalConditionQuestions.waterFlowManagementQuestions,
  },
  46: {
    formId: 2,
    sectionName: 'Fills Within 100-Year Floodplains',
    questions: generalConditionQuestions.floodplainQuestions,
  },
  47: {
    formId: 2,
    sectionName: 'Equipment',
    questions: generalConditionQuestions.equipmentQuestions,
  },
  48: {
    formId: 2,
    sectionName: 'Soil Erosion and Sediment Controls',
    questions: generalConditionQuestions.soilErosionQuestions,
  },
  49: {
    formId: 2,
    sectionName: 'Removal of Temporary Structures and Fills',
    questions: generalConditionQuestions.removalOfTempStructuresFillsQuestions,
  },
  50: {
    formId: 2,
    sectionName: 'Proper Maintenance',
    questions: generalConditionQuestions.properMaintenanceQuestions,
  },
  51: {
    formId: 2,
    sectionName: 'Single and Complete Project',
    questions: generalConditionQuestions.singleCompleteProjectQuestions,
  },
  52: {
    formId: 2,
    sectionName: 'Wild and Scenic Rivers',
    questions: [],
  },
  53: {
    formId: 2,
    sectionName: 'Tribal Rights',
    questions: generalConditionQuestions.tribalRightsQuestions,
  },
  54: {
    formId: 2,
    sectionName: 'Endangered Species',
    questions: [],
  },
  55: {
    formId: 2,
    sectionName: 'Migratory Birds and Bald and Golden Eagles',
    questions: generalConditionQuestions.migratoryBirdGoldEagleQuestions,
  },
  56: {
    formId: 2,
    sectionName: 'Historic Properties',
    questions: [],
  },
  57: {
    formId: 2,
    sectionName: 'Discovery of Previously Unknown Remains and Artifacts',
    questions: generalConditionQuestions.remainsArtifactsDiscoveryQuestions,
  },
  58: {
    formId: 2,
    sectionName: 'Designated Critical Resource Waters',
    questions: generalConditionQuestions.critResourceWatersQuestions,
  },
  59: {
    formId: 2,
    sectionName: 'Mitigation',
    questions: generalConditionQuestions.mitigationQuestions,
  },
  60: {
    formId: 2,
    sectionName: 'Safety of Impoundment Structures',
    questions: generalConditionQuestions.impoundmentStructureSafetyQuestions,
  },
  61: {
    formId: 2,
    sectionName: 'Water Quality',
    questions: generalConditionQuestions.waterQualityQuestions,
  },
  62: {
    formId: 2,
    sectionName: 'Coastal Zone Management',
    questions: generalConditionQuestions.coastalZoneManagementQuestions,
  },
  63: {
    formId: 2,
    sectionName: 'Regional and Case-By-Case Conditions',
    questions: [],
  },
  64: {
    formId: 2,
    sectionName: 'Use of Multiple Nationwide Permits',
    questions: generalConditionQuestions.multipleNwpUseQuestions,
  },
  65: {
    formId: 2,
    sectionName: 'Activities Affecting Structures or Works Built by the United States',
    questions: [],
  },
};

export const gcSections = [
  sectionsById[36],
  sectionsById[37],
  sectionsById[38],
  sectionsById[39],
  sectionsById[40],
  sectionsById[41],
  sectionsById[42],
  sectionsById[43],
  sectionsById[44],
  sectionsById[45],
  sectionsById[46],
  sectionsById[47],
  sectionsById[48],
  sectionsById[49],
  sectionsById[50],
  sectionsById[51],
  sectionsById[52],
  sectionsById[53],
  sectionsById[54],
  sectionsById[55],
  sectionsById[56],
  sectionsById[57],
  sectionsById[58],
  sectionsById[59],
  sectionsById[60],
  sectionsById[61],
  sectionsById[62],
  sectionsById[63],
  sectionsById[64],
  sectionsById[65],
];

export const nwpSections = [
  sectionsById[1],
  sectionsById[2],
  sectionsById[3],
  sectionsById[4],
  sectionsById[5],
  sectionsById[6],
  sectionsById[7],
  sectionsById[8],
  sectionsById[9],
  sectionsById[10],
  sectionsById[11],
  sectionsById[12],
  sectionsById[13],
  sectionsById[14],
  sectionsById[15],
  sectionsById[16],
  sectionsById[17],
  sectionsById[18],
  sectionsById[19],
  sectionsById[20],
  sectionsById[21],
  sectionsById[22],
  sectionsById[23],
  sectionsById[24],
  sectionsById[25],
  sectionsById[26],
  sectionsById[27],
  sectionsById[28],
  sectionsById[29],
  sectionsById[30],
  sectionsById[31],
  sectionsById[32],
  sectionsById[33],
  sectionsById[34],
  sectionsById[35],

  ...gcSections,
];
